var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 481,
    viewBox: "0 0 480 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.568 97.1102C456.595 129.412 472.111 167.238 477.687 207.108C483.263 246.978 478.72 287.61 464.477 325.264C450.233 362.918 426.746 396.384 396.179 422.581C365.611 448.779 328.944 466.866 289.554 475.179C250.163 483.491 209.315 481.761 170.768 470.148C132.222 458.535 97.216 437.412 68.9728 408.723C40.7296 380.035 20.1568 344.703 9.14801 305.98C-1.86079 267.256 -2.95181 226.386 5.97536 187.13L48.9615 196.906C41.6741 228.951 42.5647 262.314 51.5514 293.925C60.5381 325.535 77.332 354.377 100.387 377.796C123.443 401.215 152.019 418.458 183.485 427.938C214.951 437.418 248.297 438.83 280.452 432.045C312.607 425.259 342.539 410.494 367.491 389.109C392.444 367.723 411.617 340.404 423.244 309.667C434.872 278.929 438.58 245.761 434.028 213.214C429.476 180.668 416.811 149.789 397.197 123.421L432.568 97.1102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37215 194.75C13.3911 148.147 36.0268 105.265 69.4169 71.5266C102.807 37.7884 145.452 14.7092 191.959 5.2075C238.465 -4.29422 286.745 0.208297 330.693 18.1457C374.641 36.0831 412.283 66.6497 438.859 105.98L402.332 130.662C380.638 98.5553 349.91 73.6032 314.035 58.9606C278.159 44.318 238.747 40.6425 200.783 48.3989C162.819 56.1554 128.007 74.9953 100.75 102.536C73.4931 130.078 55.0151 165.083 47.6528 203.126L4.37215 194.75Z",
    fill: "#D8D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    fill: "white",
    transform: "translate(0 0.350006)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.d09e660f5ee79d4174e47d8d5b3d7a34.svg";
export { ForwardRef as ReactComponent };